/*

Constants that are long strings etc, describing or explaining something, e.g.:
	- Form hints
	- Dialog text
	- UI explanations
	- etc
*/





export const machineFormHints = {
	ASSET_ID: 'The primary identification number that your business assigns to the machine, for example, \'VM-001\'',
	MARKET_ASSET_ID: 'The primary identification number that your business assigns to the market, for example, \'VM-001\'',
	KEY: 'The number of the key used to access the asset. The key is shown in SentryMobile so that stockists know the key required to access the asset.',
	MANUFACTURER: 'The manufacturer of the asset, for example, \'Crane\', \'USI\', or \'AMS\'.',
	DISTRIBUTOR: 'The distributor of the asset, if the asset is sold by a local distributor.',
	BUILD_DATE: 'The build date of the asset.',
	MACHINE_MODEL: 'The machine\'s model, for example "USI Alpine 3000" or "Crane MEDIA Merchant 6".',
	MACHINE_TYPE: 'The machine\'s type, for example "Combo", "Drink", or "Snack". This field could be used to specify other machine types according to your business\'s operational requirements.',
	WRAP: 'The machine\'s wrap, to be used when applying exterior wraps to machines to change their appearance.',
	AERIAL_POSITION: 'The machine\'s modem\'s aerial position, for example "Inside" or "On roof".',
	MODEM: 'The modem in the asset. Use this field to pick from modems that are not assigned. Data from the selected modem will be assigned to the machine. If no modem is selected, the machine will behave as an offline machine.',
	MODEM_MARKET: 'The kiosk(s) at the market. Use this field to pick from kiosks that are not assigned. Kiosks will retrieve the market planogram and allow sales for the market. If no kiosk is selected, the market will not be able to make sales.',
	COIN_MECHANISM: 'The coin mechanism in the machine, for example "MEI Gryphon" or "NRI C2".',
	NOTE_READER: 'The note reader in the machine, for example, "MEI VN2702" or "ICT V6".',
	CONTROL_BOARD: 'The control board in the machine, to be used when modifying factory control boards.',

	PLACE: 'The place where a machine is located at its location, for example "Level 1", "Lunchroom", "Building 2 Right", or "Building 2 Left". The place is generally used to provide greater detail to indicate the place of a machine over just its location, and also to distinguish between multiple machines at the same location.',
	COMMISSION: 'Commissions are normally set on an client-basis, and apply to machines that are at locations on an client. This field is used to override the default client commission.',
	SERIAL_NUMBER: 'The original serial number of the asset.',

	// Will be moved to place at some point
	ACCESS_HOURS: 'The machine\'s access hours (not the location)',
	DIRECTIONS: 'Directions to the machine (not the location)',


};

export const RECALCULATE_UNFINISHED_PACKS_WARNING = `This recalculates pending and part-picked packs that have not been serviced.

Anything already picked stays picked. Fully picked packs are left unchanged.

Recalculate unfinished packs now?`;

export const RECALCULATE_AND_TOP_UP_ALL_WARNING = `This recalculates every unserviced pack in the run.

Anything already picked stays picked. Only extra stock now required is added to the packing work.

Recalculate and top up all packs now?`;

// Delayed native clients do not send a mode, so keep their existing
// unfinished-pack behavior while avoiding a silent all-pack top-up.
export const RECALCULATE_SERVICE_RUN_PICKLISTS_WARNING = RECALCULATE_UNFINISHED_PACKS_WARNING;


export const USER_HINTS = {
	ENABLED: 'Whether the user can log in to Sentry',
	EXCLUDE_DROPDOWNS: 'Exclude the user from dropdowns such as the driver selector for service runs',
	EXCLUDE_CLIENTS_DROPDOWNS: 'Exclude the user from dropdowns such as lead assignee and client manager selectors',
	EXCLUDE_REPORTS: 'Exclude the user from driver reports',
	HIDE_NAMES: 'Whether all machine, location, client and contact names, addresses and ticket descriptions are hidden from user',
	MANAGE_CHAT_CHANNELS: 'Lets the user rename, change the settings of and delete any Sentry Chat channel they are in. Built-in channels can only be renamed or deleted, and All AVC and Announcements always stay',
};

export const ROLE_PERMISSION_HINTS = {
	// Machines
	12:	'Whether the user can add new points of sale or edit POS information. Doesn\'t apply to POS planograms.', // 'Add/Edit machines',
	23:	'Whether the user can add or edit planograms. This permission also applies to POS planograms.', // 'Add/Edit planograms',
	// 13:	'Add/Edit locations',
	// 14:	'Edit comm devices',

	// Routes
	// 15:	'Add/Edit routes',
	// 16: 'Whether the user can plan new service runs or edit the existing ones.', //'Add/Edit service runs',
	172: 'Allows users in custom non-admin roles to be assigned to Market Setups and limits their Market Setup access to directly assigned setups. Standard Driver roles already have this access. Service run visibility is unchanged.',

	// Clients
	// 17:	'Add/Edit clients',
	11:	'Whether the user can view commission-related data across the whole system.',
	// 18:	'Add/Edit commissions',
	// 19:	'Add/Edit contacts',

	// Warehousing
	// 20:	'Add/Edit products',

	// Reports
	// 2:	'View reports',

	// Operations
	// 21:	'Add/Edit alerts',
	// 6:	'Add/Edit tickets',
	25: 'Whether the user can add or remove photos from tickets.', // 'Add/Edit ticket photos',
	3: 'Whether the user can add and remove notes, for example, to tickets or machines.', // 'Add/edit notes',
	8: 'Whether the user can view machine photos across the whole system.', // 'View machine photos',

	// Users
	5:	'Whether the user can view, create, modify or delete users and roles.', // 'Manage users and roles',

	// Settings
	10: 'Whether the user can view and change company settings.', // 'Edit company settings',
	137: 'Whether the user can view and change company settings.', // 'Edit company settings' (People app),
	9:	'Whether the user can view and change list settings.', // 'Edit list settings',
	24:	'Whether the user can view and change machine photo schedules or decide if should take photos when servicing machines.', // 'Edit machine photo settings',
	105: 'Whether the user can create, edit, delete, generate and send recurring reports.', // 'Edit recurring reports',

	// Other
	4: 'Whether the user can log into the Sentry web app', // 'Log in to web app',
	149: 'Whether the user can log into the Sentry Clients CRM app.',
	7: 'Whether the user can view and modify GPS tracking data.', // 'View gps tracking',
	// 22:	'View dashboard',
	150: 'Whether the user can view leads in the Sentry Clients CRM.',
	151: 'Whether the user can create, edit, and delete leads in the Sentry Clients CRM.',
	152: 'Whether the user can convert leads into linked client records.',
	153: 'Whether the user can view client records in the Sentry Clients CRM.',
	154: 'Whether the user can edit client records in the Sentry Clients CRM.',
	155: 'Whether the user can grant Sentry Clients app access from the People app.',
	156: 'Whether the user can view the Sentry Clients dashboard.',
	157: 'Whether the user can manage Sentry Clients users and roles.',
	173: 'Whether the user can change the account manager for an existing client or location, including state manager overrides. This does not affect assigning a manager when a client or location is first created.',
	140: 'Whether users can view other employee salaries, i.e. all non-driver/picker salaries.',
	165: 'Whether users can view driver/picker salaries, e.g. driver level 1, 2 and 3.',
	166: 'Whether users can edit driver/picker salaries, e.g. driver level 1, 2 and 3.',
	167: 'Whether users can edit other employee salaries, i.e. all non-driver/picker salaries.',
};

export const TICKET_SCHEDULE_HINTS = {
	IGNORE_NEW: 'If this is checked, machines will skip their first trigger. Tickets will be created on the normal schedule after the first trigger date has passed.',
};

export const PRODUCT_FORM_HINTS = {
	IS_FRESH_FOOD: 'Choose if product should be treated as fresh food.',
	MIN_PICK: 'The minimum number of products in a picklist required before the product is added to the pick list.',
	WEIGHT: 'Weight in grams.',
	PICK_ORDER: 'Use this field to represent the layout of your warehouse, for sorting purposes.',
	IS_INGREDIENT: 'Choose if product should be treated as an ingredient. Usually this is checked for coffee machine ingredients.',
	DECREMENT_ON_SALE: 'Decrement this ingredient by 1 unit when a machine makes a product sale. Example usage: decrement 1 cup for each product sale in a coffee machine',
	EXCLUDE_FROM_COMMISSIONS: 'Exclude all sales of this product from all commission calculations.',
};

export const ROUTE_FORM_HINTS = {
	NAME: 'The name of the route. Normally routes are organised on a geographical basis, so that routes would be called \'Melbourne South-east\'. Routes may also be organised on a driver-basis, so that a route would be called \'Maxwell Smith\'.',
	DEFAULT_DRIVER: 'When planning a service run, the assigned driver of a route will automatically be selected as the driver for a service run.',
	MARKER_COLOUR: 'When displaying the route on a map, the marker colour property sets the colour of map markers.',
	DEFAULT_START_LOCATION: 'When planning a service run, the route\'s default start location will be used when calculating the best geographic route to carry out the service run. The start location must have coordinates set for this functionality.',
	DEFAULT_END_LOCATION: 'When planning a service run, the route\'s default end location will be used when calculating the best geographic route to carry out the service run. The end location must have coordinates set for this functionality.',
	OVERRIDE_RESTOCK_EFFECT: 'The default effect of a restock (fill dex or manual restock) is to fill the machine or market with the stock listed on the picklist for the service run. This can be overridden, so that the default effect is to fill the machine or market to parlevel. This is not recommended when pre-picking picklists in your warehouse. However, if a driver fills to the maximum parlevel from their vehicle, it may be preferable to override the default restock effect. This override applies to all machines on this route.',
	PICK_WAREHOUSE: 'When using warehousing functionality, picklists made from this route will use stock from this pick warehouse. Also, when using stock forecasting functionality for a warehouse, stock forecasts will only be based on sales from machines and markets on routes that have that warehouse as their pick warehouse.',
	RETURN_WAREHOUSE: 'Return warehouse is the warehouse that will increment in excess stock scenarios. Common excess stock scenarios include: (1) When products are swapped; (2) Where excess stock is used with predictive picklists; and (3) Where inventory isn\'t accurate in markets and excess stock is present after a restock',
};

export const SERVICE_RUN_HINTS = {
	DRIVING_TIME: 'Total driving time determined by the mapping system.',
	TOTAL_TIME: 'Total expected time to complete the service run, including servicing time. Service time per machine can be adjusted in company settings.',
};

export const SERVICE_DOCKET_HINTS = {
	SERVICE_TYPE: '"Repair" services will only include visible tickets, and will not generate picklists. "Restock" services will not include tickets, but will generate picklists. "Restock and repair" services are like "restock" services, except that any visible tickets will be included.',
};
